import { InjectionToken } from '@angular/core';
import { LoggingConfig } from './logging-config.interface';
export const LOG_CONFIG = new InjectionToken<LoggingConfig>('CertMetrics Logging Config Token');
